import { useMemo } from 'react';
import { useForm, UseFormMethods } from 'react-hook-form';

import { FormData } from '~/api/models/leadads/form';

export default function useFormState(linkType: LinkType): UseFormMethods<FormData> {
  const buttonText = useMemo(() => (
    linkType === 'property'
      ? 'View Property'
      : 'Search Homes'
  ), [linkType]);

  return useForm<FormData>({
    defaultValues: {
      name: '',
      contextCardId: null,
      callingCard: {
        headline: 'View All Info Now',
        description: `Click "${buttonText}" for exclusive access to the latest listed homes for sale! Listings updated every 5 minutes.`,
        buttonText,
      },
      callToAction: 'Confirm Your Information',
      fields: {
        firstName: 'FIRST_NAME',
        lastName: 'LAST_NAME',
        email: 'EMAIL',
        phone: 'PHONE',
      },
    },
  });
}
